'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    // Always scroll to top on route change
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
